import React, { useContext, useState } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'
import { useRouter } from 'next/router'
import { LoadingCover } from '../commons/LoadingCover'
import { UserContext } from '../../context/UserContext'
import { MdOutlineSubscriptions } from 'react-icons/md'
import { AiFillThunderbolt } from "react-icons/ai";
import { HiOutlineBell, HiOutlineCalendar, HiOutlineHome } from 'react-icons/hi'
import { MdOutlineTask } from "react-icons/md";
import { isManagedTeam, isSpUi } from '../../utils/account-type'

export const MenuBar = () => {
    const router = useRouter()
    let route = router.route
    const [ isLoading, setIsLoading ] = useState(false)

    const user = useContext( UserContext )
    const { userCountryName, ongoingRequestArray, userAccountType, businessType, notificationCount } = user
    // Team members get the SP's Jobs tab (and a Calendar tab); a managed team
    // has no request feed, so no Home tab either
    const showHome = !isManagedTeam(user)

    const changeRoute = (path) =>{
        // setIsLoading(true)
        router.push(path).then((response) => {
            setIsLoading(false)
        })
    }
    
  return (
    <>
    <div className=''>
        <div id="menu-bar" className='relative z-20 md:h-12 flex justify-center md:hidden'>
            <div className="max-w-4xl flex justify-around fixed bottom-0 md:bottom-auto w-full bg-white border-t md:border-t-0 md:border-b border-gray-300 md:bg-slate-50">
                {showHome &&
                <div className='w-full'>
                        {(route === "/home" || route.includes("/home/requests")) ?
                        (
                            <button className='text-2xs md:text-base w-full p-2 text-orange-600 border-t-2 md:border-t-0 md:border-b-2 border-orange-500 md:h-12'>
                                <div className='text-2xl flex justify-center md:hidden'>
                                    <HiOutlineHome  />
                                </div>
                                {/* <div className='hidden md:block'>Requests</div> */}
                                <div className='md:hidden'>Home</div>
                            </button>
                        ):
                        (
                            <button className='text-2xs md:text-base w-full p-2 text-gray-500 md:h-12'
                                onClick={() => changeRoute("/home/requests")}
                            >
                                <div className='text-2xl flex justify-center md:hidden'>
                                    <HiOutlineHome />
                                </div>
                                {/* <div className='hidden md:block'>Requests</div> */}
                                <div className='md:hidden'>Home</div>
                            </button>
                        )
                        }
                </div>
                }
                {(isSpUi(user) || userAccountType === "Employee") &&
                    <>
                        {(businessType === "job" || businessType === "hybrid") ?
                            <div className='w-full'>
                                {route === "/jobs" ?
                                    <button className='text-2xs md:text-base w-full p-2 text-orange-600 border-t md:border-t-0 md:border-b border-orange-500 md:h-12'>
                                        <div className='text-2xl flex justify-center md:hidden'>
                                            <MdOutlineTask />
                                        </div>
                                        <div>Jobs</div>
                                    </button>
                                    :
                                    <button className='text-2xs md:text-base w-full p-2 text-gray-500 md:h-12'
                                        onClick={() => changeRoute("/jobs")}
                                    >
                                        <div className='text-2xl flex justify-center md:hidden'>
                                            <MdOutlineTask />
                                        </div>
                                        <div>Jobs</div>
                                    </button>
                                }
                            </div>
                            :
                            <div className='w-full'>
                                {route === "/history" ?
                                    <button className='text-2xs md:text-base w-full p-2 text-orange-600 border-t md:border-t-0 md:border-b border-orange-500 md:h-12'>
                                        <div className='text-2xl flex justify-center md:hidden'>
                                            <MdOutlineTask />
                                        </div>
                                        <div>Orders</div>
                                    </button>
                                :
                                    <button className='text-2xs md:text-base w-full p-2 text-gray-500 relative flex justify-center items-center md:h-12'
                                        onClick={() => changeRoute("/history")}
                                    >
                                        <div className="">
                                            <div className='text-2xl flex justify-center md:hidden'>
                                                <MdOutlineTask />
                                            </div>
                                            <div>Orders</div>                                
                                        </div>
                                    </button>
                                }
                            </div> 
                        }
                    </>
                }
                {userAccountType === "Team" &&
                    <div className='w-full'>
                        {route === "/jobs/calendar" ?
                            <button className='text-2xs md:text-base w-full p-2 text-orange-600 border-t md:border-t-0 md:border-b border-orange-500 md:h-12'>
                                <div className='text-2xl flex justify-center md:hidden'>
                                    <HiOutlineCalendar />
                                </div>
                                <div>Calendar</div>
                            </button>
                            :
                            <button className='text-2xs md:text-base w-full p-2 text-gray-500 md:h-12'
                                onClick={() => changeRoute("/jobs/calendar")}
                            >
                                <div className='text-2xl flex justify-center md:hidden'>
                                    <HiOutlineCalendar />
                                </div>
                                <div>Calendar</div>
                            </button>
                        }
                    </div>
                }
                {userAccountType === "General" &&
                    <div className='w-full'>
                        {route === "/history" ?
                            <button className='text-2xs md:text-base w-full p-2 text-orange-600 border-t md:border-t-0 md:border-b border-orange-500 md:h-12'>
                                <div className='text-2xl flex justify-center md:hidden'>
                                    <MdOutlineTask />
                                </div>
                                <div>Orders</div>
                            </button>
                        :
                            <button className='text-2xs md:text-base w-full p-2 text-gray-500 relative flex justify-center items-center md:h-12'
                                onClick={() => changeRoute("/history")}
                            >
                                {ongoingRequestArray?.length > 0 &&
                                    <div className='absolute top-0 pr-10'>
                                        <div className='px-1 bg-red-600 text-white rounded-full text-xs'>Open</div>
                                    </div>
                                }
                                <div className="">
                                    <div className='text-2xl flex justify-center md:hidden'>
                                        <MdOutlineTask />
                                    </div>
                                    <div>Orders</div>                                
                                </div>
                            </button>
                        }
                    </div> 
                }
                {(userAccountType === "Professional" || userAccountType === "Employee") &&
                    <>
                        {(businessType === "job" || businessType === "hybrid") &&
                            <div className='w-full'>
                                {route === "/home/packages" ?
                                    (
                                        <button className='text-2xs md:text-base w-full p-2 text-orange-600 border-t md:border-t-0 md:border-b border-orange-500 md:h-12'>
                                            <div className='text-2xl flex justify-center md:hidden'>
                                                <MdOutlineSubscriptions />
                                            </div>
                                            <div>Packages</div>
                                        </button>
                                    ):
                                    (
                                        <button className='text-2xs md:text-base w-full p-2 text-gray-500 md:h-12'
                                            onClick={() => changeRoute("/home/packages")}
                                        >
                                            <div className='text-2xl flex justify-center md:hidden'>
                                                <MdOutlineSubscriptions />
                                            </div>
                                            <div>Packages</div>
                                        </button>
                                    )
                                }
                            </div>
                        }
                    </>
                }
                {userAccountType === "General" &&
                    <div className='w-full'>
                        {route === "/account/my-packages" ?
                            (
                                <button className='text-2xs md:text-base w-full p-2 text-orange-600 border-t md:border-t-0 md:border-b border-orange-500 md:h-12'>
                                    <div className='text-2xl flex justify-center md:hidden'>
                                        <MdOutlineSubscriptions />
                                    </div>
                                    <div>Packages</div>
                                </button>
                            ):
                            (
                                <button className='text-2xs md:text-base w-full p-2 text-gray-500 md:h-12'
                                    onClick={() => changeRoute("/account/my-packages")}
                                >
                                    <div className='text-2xl flex justify-center md:hidden'>
                                        <MdOutlineSubscriptions />
                                    </div>
                                    <div>Packages</div>
                                </button>
                            )
                        }
                    </div>
                } 
                {/* {(userCountryName === "Singapore" && userAccountType === "General") &&
                    <div className='w-full'>
                            {route === "/home/deals/fitness-deals" ?
                            (
                                <button className='text-xs md:text-base w-full p-2 text-orange-600 border-t md:border-t-0 md:border-b border-orange-500 md:h-12'>
                                    <div className='text-2xl flex justify-center md:hidden'>
                                        <IoGift  />
                                    </div>
                                    <div>Deals</div>
                                </button>
                            ):
                            (
                                <button className='text-xs md:text-base w-full p-2 text-gray-500 md:h-12'
                                    onClick={() => changeRoute("/home/deals")}
                                >
                                    <div className='text-2xl flex justify-center md:hidden'>
                                        <IoGiftOutline  />
                                    </div>
                                    <div>Deals</div>
                                </button>
                            )
                            }
                    </div>
                } */}
                {/* <div className='w-full'>
                        {route === "/home/buzz" ?
                        (
                            <button className='text-2xs md:text-base w-full p-2 text-orange-600 border-t md:border-t-0 md:border-b border-orange-500 md:h-12'>
                                <div className='text-2xl flex justify-center md:hidden'>
                                    <AiFillThunderbolt  />
                                </div>
                                <div>Buzz</div>
                            </button>
                        ):
                        (
                            <button className='text-2xs md:text-base w-full p-2 text-gray-500 md:h-12'
                                onClick={() => changeRoute("/home/buzz")}
                            >
                                <div className='flex justify-center md:hidden'>
                                    <Image
                                        src={s3Static + "buzz-icon.gif"}
                                        height={24}
                                        width={24}
                                        alt='StringsSG Referral Program' />
                                </div>
                                <div>Buzz</div>
                            </button>
                        )
                        }
                </div> */}
                <div className='w-full md:hidden'>
                    {route === "/notification" ?
                        (
                            <button className='text-2xs md:text-base w-full p-2 text-orange-600 border-t md:border-t-0 md:border-b border-orange-500 md:h-12'>
                                <div className='text-2xl flex justify-center md:hidden'>
                                    <div className='flex items-center relative'>
                                        <span className="">
                                            <HiOutlineBell/>
                                        </span>
                                        {notificationCount > 0 &&
                                            <div className={(notificationCount > 20 ? " -right-3 " : " -right-1" ) + (` absolute -top-2 flex`)}>
                                                <span className='bg-red-600 text-white px-1 rounded-full text-xs'>
                                                    {notificationCount > 20 ? "20+" : notificationCount}
                                                </span>
                                            </div>                                            
                                        } 
                                    </div>
                                </div>
                                <div>Notifications</div>
                            </button>
                        ):
                        (
                            <button className='text-2xs md:text-base w-full p-2 text-gray-500 md:h-12'
                                onClick={() => changeRoute("/notification")}
                            >
                                <div className='text-2xl flex justify-center md:hidden'>
                                    <div className='flex items-center relative'>
                                        <span className="">
                                            <HiOutlineBell/>
                                        </span>
                                        {notificationCount > 0 &&
                                            <div className={(notificationCount > 20 ? " -right-3 " : " -right-1" ) + (` absolute -top-2 flex`)}>
                                                <span className='bg-red-600 text-white px-1 rounded-full text-xs'>
                                                    {notificationCount > 20 ? "20+" : notificationCount}
                                                </span>
                                            </div>                                            
                                        } 
                                    </div>
                                </div>
                                <div>Notifications</div>
                            </button>
                        )
                    }
                </div>
            </div>        
        </div>
    </div>
    {isLoading &&
        <LoadingCover/>
    }
    </>
  )
}
